import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './context/AuthProvider';
import { SocketProvider } from './context/SocketProvider';
import theme from './theme';
import Layout from './components/Layout';
import Missing from './components/Missing';

import {
  Login,
  Unauthorized,
  PersistLogin,
  RequireAuth,
  Home,
  Report,
  RequireManager,
  ManagerPanel,
  RequireAdmin,
  AdminPanel,
  WorkspacesPanel,
  FindAFix,
  AssessmentCreator,
} from './components/index';

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Login />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/unauthorized',
        element: <Unauthorized />,
      },
      {
        element: <PersistLogin />,
        children: [
          {
            element: <RequireAuth />,
            children: [
              {
                element: <RequireAuth />,
                children: [
                  {
                    path: '/home',
                    element: <Home />,
                  },
                  {
                    path: '/report/:id',
                    element: <Report />,
                  },
                  ...(['beta', 'local'].includes(
                    process.env.REACT_APP_SERVER_ENV as string,
                  )
                    ? [
                        {
                          path: '/find-a-fix',
                          element: <FindAFix />,
                        },
                        {
                          path: '/assessment-creator',
                          element: <AssessmentCreator />,
                        },
                      ]
                    : []),
                  {
                    element: <RequireManager />,
                    children: [
                      {
                        path: '/manager',
                        element: <ManagerPanel />,
                      },
                    ],
                  },
                  {
                    element: <RequireAdmin />,
                    children: [
                      {
                        path: '/admin',
                        element: <AdminPanel />,
                      },
                      {
                        path: '/admin/workspaces',
                        element: <WorkspacesPanel />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      { path: '*', element: <Missing /> },
    ],
  },
]);

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    // <React.StrictMode>
    <AuthProvider>
      <SocketProvider>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </SocketProvider>
    </AuthProvider>,
    // </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
